import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PujasService {
  baseUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) {}
  postPuja(idLote, monto) {
    return this.httpClient.post(
      this.baseUrl + '/puja/' + idLote + '/' + monto,
      {}
    );
  }

  postCompraDirecta(idLote, monto) {
    return this.httpClient.post(
      this.baseUrl + '/compra-directa/' + idLote + '/' + monto,
      {}
    );
  }

  getPujas(idLote) {
    return this.httpClient.get(this.baseUrl + '/pujas/' + idLote);
  }
}
